import { render } from "./Key8.vue?vue&type=template&id=61468de2"
import script from "./Key8.vue?vue&type=script&lang=ts"
export * from "./Key8.vue?vue&type=script&lang=ts"
script.render = render

export default script